module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Yu-Han-bf0c05cb28b1f982c27e1495e03eacdd.jpg";